import React from 'react';
import styled from 'styled-components';
import { ErrorMessage } from './ErrorMessage';
import { PersistentErrorMessage } from './PersistentErrorMessage';

const TableMessages = styled.div`
  font-family: 'Whitney Medium';
  font-size: 1rem;
  .missing {
    color: #bf1e2d;
  }
`;

export function ClinicPersonnelTableErrorMessages({ persistentErrorMessages, validationErrors, showErrors }) {
  // persistentErrorMessages contains a map of error message keys to text of the error message
  // We will show the persistentErrorMessages at all times
  // If the error is actually applies we show it in red, otherwise we use the default color
  // We know that the error applies if the key is in validationErrors

  const { base, people } = validationErrors;

  // "plain error" are errors that are only rendered if the form contains that particulare error, as opposed to "persistent errors",
  // which are always rendered, whether the error is present or not.
  const plainErrors = (base || []).concat(people || []).flat();

  return (
    <TableMessages>
      {Object.keys(persistentErrorMessages).map((key, i) => (
        <PersistentErrorMessage
          key={key}
          error={validationErrors.hasOwnProperty(key)}
        >
          {persistentErrorMessages[key]}
        </PersistentErrorMessage>
      ))}
      {showErrors
        && plainErrors.map((errorMessage, i) => <ErrorMessage key={i}>{errorMessage}</ErrorMessage>)}
    </TableMessages>
  );
}
